import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {AuthProvider} from './context/AuthProvider'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
// import SimpleBottomNavigation from './components/SimpleBottomNavigation'
// import { Offline, Online } from "react-detect-offline";

// Disabling React Dev Tools
if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}
//ERROR cancel NO FUNCIONA EN REACT 18 CON EL NUEVO RENDER (POR ESO ESTA CON LA ANTIGUA SINTAXIS)
ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
           <Route path='/*' element={<App />}></Route> 
          </Routes>
          {/* <SimpleBottomNavigation /> */}
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
serviceWorkerRegistration.register({
  onUpdate: async (registration) => {
    // Corremos este código si hay una nueva versión de nuestra app
    // Detalles en: https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle
    if (registration && registration.waiting) {
      await registration.unregister();
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      // Des-registramos el SW para recargar la página y obtener la nueva versión. Lo cual permite que el navegador descargue lo nuevo y que invalida la cache que tenía previamente.
      window.location.reload();
    }
  },
});